// ── Navigation ─────────────────────────────
function toggleMenu() {
document.getElementById('mmenu').classList.toggle('open');
}

window.addEventListener('scroll', function() {
document.getElementById('mainnav').classList.toggle('sh', window.scrollY > 40);
});

// ── Scroll reveal ────────────────────────────
var obs = new IntersectionObserver(function(entries) {
entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.08 });
document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });

// ── Sélecteur taille ─────────────────────────
function selSz(groupId, btn) {
var group = document.getElementById(groupId);
if (!group) return;
group.querySelectorAll('.sz-btn').forEach(function(b) { b.classList.remove('on'); });
btn.classList.add('on');
updateVariant();
}

// ── Sélecteur couleur ────────────────────────
var selectedColor = '';
function setColor(btn, color, gradient) {
selectedColor = color;
document.querySelectorAll('.swatch').forEach(function(b) { b.classList.remove('on'); });
btn.classList.add('on');
var preview = document.getElementById('tshirt-preview');
if (preview) preview.style.background = gradient;
var lbl = document.getElementById('color-uni-label');
if (lbl) lbl.textContent = color;
updateVariant();
}

// ── Mise à jour variante Shopify ─────────────
function updateVariant() {
var sizeBtn = document.querySelector('#sizes-uni .sz-btn.on') || document.querySelector('#home-sizes-uni .sz-btn.on');
var size = sizeBtn ? sizeBtn.dataset.size || sizeBtn.textContent.trim() : 'M';
var sel = document.getElementById('variant-id');
if (!sel || !selectedColor) return;
var options = sel.querySelectorAll('option');
for (var i = 0; i < options.length; i++) {
if (options[i].dataset.color === selectedColor && options[i].dataset.size === size) {
sel.value = options[i].value;
break;
}
}
}

// ── Quantité ─────────────────────────────────
var qtyVal = 1;
function changeQty(dir) {
qtyVal = Math.max(1, Math.min(10, qtyVal + dir));
var el = document.getElementById('qty-display');
if (el) el.textContent = qtyVal;
var qIn = document.getElementById('qty-input');
if (qIn) qIn.value = qtyVal;
}

// ── FAQ accordion ────────────────────────────
function faq(el) {
var item = el.closest('.faq-item');
var wasOpen = item.classList.contains('open');
document.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
if (!wasOpen) item.classList.add('open');
}

// ── Carrousels ───────────────────────────────
var carState = {};
function carInit(id) {
carState[id] = 0;
var track = document.getElementById(id + '-track');
if (!track) return;
var startX = 0;
track.parentElement.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
track.parentElement.addEventListener('touchend', function(e) {
var diff = startX - e.changedTouches[0].clientX;
if (Math.abs(diff) > 40) carMove(id, diff > 0 ? 1 : -1);
});
}
function carMove(id, dir) {
var track = document.getElementById(id + '-track');
if (!track) return;
var count = track.querySelectorAll('.car-slide').length;
carState[id] = (carState[id] + dir + count) % count;
updateCar(id);
}
function carGo(id, idx) { carState[id] = idx; updateCar(id); }
function updateCar(id) {
var track = document.getElementById(id + '-track');
if (!track) return;
track.style.transform = 'translateX(-' + (carState[id] * 100) + '%)';
document.querySelectorAll('#' + id + '-dots .car-dot').forEach(function(d, i) {
d.classList.toggle('on', i === carState[id]);
});
}

// ── Init ─────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
carInit('vals');
carInit('why');
carInit('ps');
carInit('livr');
});

